import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector, useDispatch } from 'react-redux'
import { selectEditableLoanEstimatedBalance } from '../../../../../store/selectors/home/loans'
import { cancelEditBalance } from '../../../../../actions/loan'

import { Button, Format, Panel, Text } from '../../../..'

import styles from './EditBalanceInterstitial.module.scss'

const propTypes = {
  hideInterstitial: PropTypes.func,
}

const EditBalanceInterstital = ({ hideInterstitial }) => {
  const estimatedValue = useSelector(selectEditableLoanEstimatedBalance)
  const dispatch = useDispatch()

  return (
    <>
      <Panel.Heading>
        <FormattedMessage
          id='Mortgages.editBalance.interstitialHeading'
          defaultMessage='Made extra payments?'
        />
      </Panel.Heading>

      <div className={styles.text}>
        <Text
          size='l'
          weight='light'
          align='center'
          variant='neutralCool'
          variantCount='900'
        >
          <FormattedMessage
            id='Mortgages.editBalance.interstitialSubheading'
            defaultMessage='We’ve estimated your balance is {balance}'
            values={{
              balance: <Format.Currency value={estimatedValue} format='0,0' />,
            }}
          />
        </Text>
      </div>

      <div className={styles.text}>
        <Text variant='neutralCool' variantCount='700' size='s' align='center'>
          <FormattedMessage
            id='Mortgages.editBalance.interstitialExplainer'
            defaultMessage="If you've made extra principal payments or have had your balance adjusted, it's good to true-up your balance here. Otherwise, you can stay on auto-pilot and we'll keep you up to date each month!"
          />
        </Text>
      </div>

      <Button.Group align='center'>
        <Button
          onClick={hideInterstitial}
          data-qa='EditBalanceInterstitialNextButton'
        >
          <FormattedMessage
            id='Mortgages.editBalance.interstitialChangeButton'
            defaultMessage='Yes, change'
          />
        </Button>
        <Button
          onClick={() => dispatch(cancelEditBalance())}
          data-qa='EditBalanceInterstitialCancelButton'
        >
          <FormattedMessage
            id='Mortgages.editBalance.interstitialSkipButton'
            defaultMessage='Skip for now'
          />
        </Button>
      </Button.Group>
    </>
  )
}

EditBalanceInterstital.propTypes = propTypes

export default EditBalanceInterstital
